<template>
  <div class="grid grid-cols-1 md:grid-cols-2 min-h-screen">
    <div>
      <header class="flex justify-between py-4 px-8">
        <MobiusLogo />
        <router-link
          :to="{
            path: '/v2/auth/login',
            query: $route.query.redirect ? { redirect: $route.query.redirect } : {},
          }"
          class="text-neutral-700"
        >
          ¿Ya tienes una cuenta?
          <span class="font-bold">Inicia sesión</span>
        </router-link>
      </header>
      <div class="px-5 py-8 md:py-14 text-center m-auto max-w-[400px]" v-if="!this.postRegister">
        <RegisterForm @postRegisterOk="postRegisterOk"/>
      </div>
      <div
        v-else
        class="m-auto mt-4 p-4 text-center"
        style="max-width: 500px"
      >
        <h2 class="h4 mt-4">
          Hemos enviado un correo de verficación al email que usaste para
          registrarte
        </h2>
      </div>
    </div>
    <div class="hidden md:block">
      <RegisterBanner />
    </div>
  </div>
</template>

<script>
import RegisterForm from "./RegisterForm.vue";
import RegisterBanner from "./RegisterBanner.vue";
import MobiusLogo from "@/components/MobiusLogo.vue";

export default {
  name: "RegisterV2",
  components: {
    RegisterForm,
    RegisterBanner,
    MobiusLogo,
  },
  data() {
    return {
      postRegister: false,
    }
  },
  methods: {
    postRegisterOk() {
      this.postRegister = true;
    }
  }
};
</script>
